module.exports = __webpack_public_path__ + "static/media/008.86196164.jpg";